module.exports = __webpack_public_path__ + "img/c_photo_2.40916ade.png";